import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// ANT DESIGN IMPORTS
import { CheckCircleOutlined } from "@ant-design/icons";
import {
  Card,
  Input,
  Row,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Typography,
} from "antd";

// PROJECT IMPORTS
import DownloadTableButtons from "../../../components/DownloadTableButtons";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import { apiConfig, labelConfig, staticConfig } from "../security.config";

import SortableColumn from "../../../components/SorterTableColumn";
import { rightAction } from "../../../redux/actions";

const columns = [
  SortableColumn({
    label: labelConfig.firstname,
    dataIndex: "firstname",
    sorter: (a, b) => a.firstname.localeCompare(b.firstname),
  }),
  SortableColumn({
    label: labelConfig.lastname,
    dataIndex: "lastname",
    sorter: (a, b) => a.lastname.localeCompare(b.lastname),
  }),
  {
    title: "Email",
    dataIndex: "email",
  },
  SortableColumn({
    label: labelConfig.branch,
    dataIndex: "officeName",
    sorter: (a, b) => a.officeName.localeCompare(b.officeName),
  }),
  {
    title: "Status",
    dataIndex: "status",
    render: (status, record) => {
      if (status === "enabled") {
        return (
          <Tag icon={<CheckCircleOutlined />} color={"success"}>
            Enabled
          </Tag>
        );
      } else {
        return (
          <Tag icon={<CheckCircleOutlined />} color={"red"}>
            Disabled
          </Tag>
        );
      }
    },
  },
];

const ManageUsers = (props) => {
  //DECLARED VARIABLES
  const { userData, rightBtn, rightAction } = props;
  const { session } = userData;
  const { Text } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tableCount, setTableCount] = useState("10");
  const [searchKey, setSearchKey] = useState("");
  const [statusFilter, setStatusFilter] = useState("Enabled");
  const [manageUsersList, setManageUsersList] = useState([]);
  const [originalList, setOriginalList] = useState([]);

  useEffect(() => {
    BOM.HasPermission("READ_USER") && getmanageUsersListAction();
    BOM.HasPermission("CREATE_USER") && rightAction(cnt.RIGHT_ADD_BTN);
  }, []);
  useEffect(() => {
    if (!searchKey && !statusFilter) {
      console.log("i ran");
      setManageUsersList(originalList);
      return;
    }
    console.log(statusFilter, searchKey, "ss");
    if (searchKey.length > 0) {
      const filterBySearch = originalList.filter(
        (item) =>
          item?.lastname.toLowerCase()?.includes(searchKey.toLowerCase()) ||
          item?.firstname.toLowerCase()?.includes(searchKey.toLowerCase())
      );
      setManageUsersList(filterBySearch);
      // setStatusFilter("All");
      // setManageUsersList(originalList);
      return;
    }
    if (statusFilter && statusFilter.toLowerCase() !== "all") {
      const filterByStatus = originalList.filter((item) =>
        item?.status.toLowerCase()?.includes(statusFilter.toLowerCase())
      );
      setManageUsersList(filterByStatus);
      // setSearchKey("");
      // setManageUsersList(originalList);

      return;
    }
    setManageUsersList(originalList);
  }, [searchKey, statusFilter, originalList]);

  const getmanageUsersListAction = () => {
    const url = `${apiConfig.Users}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            firstname: element?.firstname
              ? element?.firstname
              : "No First Name",
            lastname: element?.lastname ? element?.lastname : "No Last Name",
            officeName: element?.officeName
              ? element?.officeName
              : "No Office Description",
            email: element?.email ? element?.email : "No Email",
            status: element?.enabled ? "enabled" : "disabled",
            // status: element?.enabled ? 'enabled'
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        // setManageUsersList(tempArray.filter((item) => item.disabled === false));
        // setManageUsersList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getCsvListData = () => {
    return new Promise((resolve, reject) => {
      const params = {
        limit: 1000,
        offset: 0,
      };

      let body = {
        session,
        params,
      };

      const url = `${apiConfig.Users}`;

      BOM.FetchReqAction(body, url, (err, res) => {
        if (err) {
          reject(err);
        } else {
          const objList = res;
          let tempArray = [];

          objList.forEach((element) => {
            tempArray.push({
              key: element?.id,
              id: element?.id,
              firstname: element?.firstname
                ? element?.firstname
                : "No First Name",
              lastname: element?.lastname ? element?.lastname : "No Last Name",
              officeName: element?.officeName
                ? element?.officeName
                : "No Office Description",
              email: element?.email ? element?.email : "No Email",
              status: element?.enabled ? "enabled" : "disabled",
              // status: element?.enabled ? 'enabled'
            });
          });

          resolve(tempArray);
        }
      });
    });
  };

  //DECLARED METHODS
  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_USER") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_USER") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  function handleSearchInTable(_searchKey) {
    _searchKey = _searchKey.target.value;
    setSearchKey(_searchKey);
    setStatusFilter("All");
    console.log(_searchKey);

    // if (!searchKey) {
    //   setManageUsersList(originalList);
    //   return;
    // }
    // const filterBySearch = originalList.filter(
    //   (item) =>
    //     item?.lastname.toLowerCase()?.includes(searchKey.toLowerCase()) ||
    //     item?.firstname.toLowerCase()?.includes(searchKey.toLowerCase())
    // );
    // setManageUsersList(filterBySearch);
  }

  function selectTableCount(value) {
    setTableCount(value);
  }

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/view-sms0100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/add-sms0100", { ofObj: selectedRow });
    } else {
      console.log("Could not open the link");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-sms0100", { state: selectedRow });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleFilterByStatus(newStatus) {
    setStatusFilter(newStatus);
    setSearchKey("");
    // setStatusFilter(newStatus);
    // if (!newStatus) {
    //   setManageUsersList(originalList);
    //   return;
    // }
    // if (newStatus.toLowerCase() === "all") {
    //   setManageUsersList(originalList);
    //   return;
    // }
    // const filterBySearch = originalList.filter((item) =>
    //   item?.status.toLowerCase()?.includes(newStatus.toLowerCase())
    // );
    // setManageUsersList(filterBySearch);
  }

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onView={handleOnView}
      onAdd={handleOnCreate}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={labelConfig.manageUsers}
        pageItems={staticConfig.manageUsersItems}
      />

      <Card
        title={`${labelConfig.listOfUsers}`}
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        {/* RENDER TABLE LIST HERE*/}
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={selectTableCount}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>

            <div style={{ margin: "0px 20px 0px 50px" }}>
              <Input
                onChange={handleSearchInTable}
                value={searchKey}
                placeholder="Search by Name..."
                style={{
                  width: 400,
                }}
              />
            </div>
            {/* <Space
              style={{
                // marginLeft: 10,
                alignSelf: "center",
              }}
              direction="vertical"
            > */}
            <Select
              defaultValue={statusFilter}
              options={staticConfig.statusLabels}
              onSelect={handleFilterByStatus}
              value={statusFilter}
              bordered={false}
              style={{
                backgroundColor: "#F9FAFB",
                border: "1px solid #EAECF0",
                // backgroundColor: "transparent",
                borderRadius: 50,
                height: 30,

                // minWidth: 120,
              }}
              dropdownStyle={{
                borderRadius: 8,
                width: "250px",
              }}
            />
            {/* </Space> */}
            <DownloadTableButtons
              downloadData={manageUsersList}
              columns={columns}
              fileName={"Users List"}
              onExportClick={getCsvListData}
            />
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={manageUsersList}
            bordered
            pagination={{
              position: "bottomCentre",
              pageSize: tableCount,
              showSizeChanger: false,
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };
export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);
